import { Select, SelectProps } from 'zens-storybook'
import React from 'react'
import { StyleSheet } from 'react-native'
import { useBuildings, useLocations } from 'zens-store'
import { Href } from 'zens-router'

const styles = StyleSheet.create({
  container: {},
})

interface Props extends Omit<SelectProps<number>, 'items' | 'onSelect'> {
  companyId: number
  locationId?: number
  onChange?: (value: number) => void
  groupLocation?: boolean
  href?: (buildingId: number) => Href
}

const BuildingSelect = (props: Props) => {
  const { onChange, companyId, locationId, groupLocation, href, style, ...otherProps } = props

  const buildings = useBuildings({ companyId, locationId })
  const locations = useLocations({ companyId }, { enabled: groupLocation })

  const items = groupLocation
    ? locations.data?.map((location) => ({
        title: location.name,
        items:
          buildings.data
            ?.filter((building) => building.locationId === location.id)
            .map((building) => ({
              value: building.id,
              title: building.name,
              href: href?.(building.id),
            })) || [],
      }))
    : buildings.data?.map((building) => ({
        value: building.id,
        title: building.name,
      }))

  return (
    <Select
      style={[styles.container, style]}
      onSelect={onChange}
      items={items}
      testID="BuildingSelect.Container"
      {...otherProps}
    />
  )
}

export default BuildingSelect
